import React from 'react';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  return <section id="bonos" className="relative z-10 py-8 md:py-12 px-4 cosmic-bg" data-id="element-48">
      <div className="max-w-4xl mx-auto" data-id="element-49">
        {/* Section Header */}
        <div className="text-center mb-8" data-id="element-50">
          <div className="inline-flex items-center gap-2 bg-green-500/20 border border-green-500/40 rounded-full px-5 py-1.5 mb-4" data-id="element-51">
            <GiftIcon className="w-4 h-4 text-green-400" data-id="element-52" />
            <span className="text-green-400 font-bold text-xs uppercase tracking-wider" data-id="element-53">
              ¡GRATIS por el día de hoy!
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-54">
            Además, llevás estos{' '}
            <span className="text-gold-gradient" data-id="element-55">BONOS EXCLUSIVOS</span>
          </h2>
          <p className="text-base text-white/70" data-id="element-56">
            Incluidos sin costo adicional con tu compra de hoy
          </p>
        </div>

        {/* Bonus Cards - Compact Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-57">
          {/* Bonus 1 */}
          <a href="#comprar" className="group bg-[#1a1030] border border-[#F5C842]/20 rounded-xl p-4 transition-all duration-300 hover:border-[#F5C842]/50 hover:shadow-lg hover:shadow-[#F5C842]/10" data-id="element-58">
            <div className="flex items-center gap-2 mb-2" data-id="element-59">
              <span className="text-2xl" data-id="element-60">🎁</span>
              <span className="text-xs font-bold text-[#F5C842] uppercase tracking-wider" data-id="element-61">
                BONUS #1
              </span>
            </div>
            <h3 className="text-base font-bold text-white mb-2" data-id="element-62">
              Pack Premium de Diseño
            </h3>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-63">
              10 portadas editables, 5 estilos de informes interiores, paletas
              de color profesionales.
            </p>
          </a>

          {/* Bonus 2 */}
          <a href="#comprar" className="group bg-[#1a1030] border border-[#F5C842]/20 rounded-xl p-4 transition-all duration-300 hover:border-[#F5C842]/50 hover:shadow-lg hover:shadow-[#F5C842]/10" data-id="element-64">
            <div className="flex items-center gap-2 mb-2" data-id="element-65">
              <span className="text-2xl" data-id="element-66">🎁</span>
              <span className="text-xs font-bold text-[#F5C842] uppercase tracking-wider" data-id="element-67">
                BONUS #2
              </span>
            </div>
            <h3 className="text-base font-bold text-white mb-2" data-id="element-68">
              Biblioteca de 25 Interpretaciones
            </h3>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-69">
              Textos listos con redacción cálida y profesional, listas para
              personalizar en minutos.
            </p>
          </a>

          {/* Bonus 3 */}
          <a href="#comprar" className="group bg-[#1a1030] border border-[#F5C842]/20 rounded-xl p-4 transition-all duration-300 hover:border-[#F5C842]/50 hover:shadow-lg hover:shadow-[#F5C842]/10" data-id="element-70">
            <div className="flex items-center gap-2 mb-2" data-id="element-71">
              <span className="text-2xl" data-id="element-72">🎁</span>
              <span className="text-xs font-bold text-[#F5C842] uppercase tracking-wider" data-id="element-73">
                BONUS #3
              </span>
            </div>
            <h3 className="text-base font-bold text-white mb-2" data-id="element-74">
              Kit Ingresos Recurrentes
            </h3>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-75">
              Plantillas de informes mensuales y modelo de suscripción para
              generar ingresos predecibles.
            </p>
          </a>
        </div>
      </div>
    </section>;
}